<script>
	export default {
		created() {
			//根据参数 重定向指定页面
			const {
				query
			} = this.$route
			this.$replace({
				path: query.redirect
			})
		},
		render: function(h) {
			return h() 
		}
	}
</script>
